export function tab() {
  const tabRoots = document.querySelectorAll(".c-tab");

  tabRoots.forEach((root) => {
    const tabMenu = root.querySelectorAll(".c-tab__menuItem");
    const tabContent = root.querySelectorAll(".c-tab__contentItem");
    if (!tabMenu.length || tabMenu.length !== tabContent.length) return;

    tabMenu.forEach((btn, index) => {
      btn.addEventListener("click", () => {
        tabMenu.forEach((item, i) => {
          const on = i === index;
          item.classList.toggle("js-tab-active", on);
          item.setAttribute("aria-selected", String(on));
          item.tabIndex = on ? 0 : -1;
          const panel = tabContent[i];
          panel.classList.toggle("is-active", on);
          if (on) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });

        const panel = tabContent[index];
        const img = panel.querySelector(":scope > img");
        const p = panel.querySelector(":scope > p");
        if (typeof gsap === "undefined" || !img || !p) return;

        gsap
          .timeline()
          .fromTo(
            img,
            { clipPath: "inset(0 100% 0 0)" },
            { clipPath: "inset(0 0% 0 0)", duration: 0.3 }
          )
          .fromTo(
            p,
            { clipPath: "inset(0 100% 0 0)" },
            { clipPath: "inset(0 0% 0 0)", duration: 0.3 },
            ">"
          );
      });
    });
  });
}
